import React, { useState, useRef, useEffect } from 'react'
import styles from './ProfileImageModal.module.css'
import userIcon from '../../assets/icons/profileIconBig.svg'

const ProfileImageModal = ({ isOpen, onClose, onSave, currentImage }) => {
  const [previewImage, setPreviewImage] = useState(currentImage)
  const [selectedFile, setSelectedFile] = useState(null)
  const fileInputRef = useRef(null)

  useEffect(() => {
    if (isOpen) {
      setPreviewImage(currentImage)
      setSelectedFile(null)
    }
  }, [isOpen, currentImage])

  if (!isOpen) return null

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0]
    if (file) {
      setSelectedFile(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreviewImage(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSave = () => {
    onSave(selectedFile)
    onClose()
  }

  const handleCancel = () => {
    setPreviewImage(currentImage)
    setSelectedFile(null)
    onClose()
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>프로필 사진 변경</h2>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.previewSection}>
            <div className={styles.previewAvatar}>
              {previewImage ? (
                <img src={previewImage} alt="Preview" />
              ) : (
                <img src={userIcon} alt = "유저아이콘" draggable={false}/>
              )}
            </div>
            <p className={styles.previewLabel}>미리보기</p>
          </div>

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />

          <button 
            className={styles.selectBtn}
            onClick={() => fileInputRef.current?.click()}
          >
            <i className="fas fa-image"></i>
            사진 선택
          </button>

          <p className={styles.helpText}>
            JPG, PNG 파일을 선택해주세요.
          </p>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.cancelBtn} onClick={handleCancel}>
            취소
          </button>
          <button 
            className={styles.confirmBtn} 
            onClick={handleSave}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProfileImageModal
